export default __webpack_public_path__ + "static/media/Lärarlyftet_ljudläggare_mixare_2021.4335a30a.png";